import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, formatApiError } from "@/shared/context/AuthContext";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await register(name, email, password);
      const redirect = sp.get("redirect");
      nav(redirect || "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <div className="label-xs text-[#ed6500] mb-6">Create account</div>
      <h1 className="font-serif font-light text-5xl leading-[0.95] tracking-tighter mb-10">Start a plan.</h1>
      <form onSubmit={submit} className="space-y-8">
        <div><div className="label-xs mb-3">Full name</div><input className="input-line" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name"/></div>
        <div><div className="label-xs mb-3">Email</div><input className="input-line" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email"/></div>
        <div>
          <div className="label-xs mb-3">Password</div>
          <div className="relative">
            <input
              className="input-line pr-10"
              type={showPw ? "text" : "password"}
              minLength={6} required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password"
            />
            <button
              type="button"
              onClick={() => setShowPw((v) => !v)}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-[#515E7B] hover:text-[#0A1128] p-1"
              tabIndex={-1}
              aria-label={showPw ? "Hide password" : "Show password"}
              data-testid="register-password-toggle"
            >
              {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>
        <button disabled={busy} className="btn-primary text-xs tracking-widest uppercase disabled:opacity-60" data-testid="register-submit">{busy ? "Creating…" : "Create account"}</button>
      </form>
      <div className="mt-8 label-xs text-[#515E7B]">
        Already have an account? <Link to="/login" className="text-[#ed6500] hover:underline" data-testid="login-link">Sign in</Link>
      </div>
    </div>
  );
}
